import styled from 'styled-components'

export const ButtonImage = styled.img`
  height: 50px;
  width: 50px;
  cursor: pointer;
`
